// Copyright ©️ 2025 eVolve MEP, LLC

import type { Position } from '@xyflow/react';

import type { NodeReferenceId } from 'modules/Shop/CatalogSetup/PartEditor/nodes/types';

declare const assemblyEdgeIdSymbol: unique symbol;
export type AssemblyEdgeId = string & { [assemblyEdgeIdSymbol]: never };

export type CustomAssembly = {
  version: 1 | 2;
  nodePositions: Partial<
    Record<
      NodeReferenceId,
      {
        x: number;
        y: number;
      }
    >
  >;
  edges: {
    edgeId: AssemblyEdgeId;
    beginHandlePosition: Position;
    endHandlePosition: Position;
    beginNodeId: NodeReferenceId;
    endNodeId: NodeReferenceId;
  }[];
};

/**
 * The `AssemblyItemId` used to track the core Assembly node in an assembly
 */
export const CoreNodeId = 'core-part' as const;
